import React from "react";
import PropTypes from "prop-types";

import Application from "shared/application";
import Tile, {
  TileTitle,
  TileHeader,
  TileBody
} from "shared/react_components/Tile";
import DataList from "shared/react_components/DataList";

import OptionalDatumCol from "./OptionalDatumCol";
import { disqualifiedExpressionWithLabeling, expressionTextToNodeList } from "shared/utils/expressionFormatting";

const renderMoney = amount => amount && `${Application.currency}${amount}`;
const renderConditions = conditions => conditions && disqualifiedExpressionWithLabeling(expressionTextToNodeList(conditions));

const payInLabel = { NETWORK: "Earned", ADVERTISER: "Payout", AFFILIATE: "Earned" };
const payInConditionLabel = { NETWORK: "Payin Conditions", ADVERTISER: "Payout Conditions", AFFILIATE: "Payin Conditions" };
const payOutLabel = { NETWORK: "Paid", ADVERTISER: "Paid", AFFILIATE: "Earnings" };

const ConversionData = ({
  aliases,
  result,
  payIn,
  payInConditions,
  payOut,
  payOutConditions,
  margin,
  fees,
  advertiserFees,
  saleAmount,
  reportMetadata
}) => {
  return (
    <Tile style={{ height: 400 }}>
      <TileHeader>
        <TileTitle>Conversion Data</TileTitle>
      </TileHeader>
      <TileBody>
        <DataList className="row">
          <OptionalDatumCol label="Revenue (Sale Amount)">
            {renderMoney(saleAmount)}
          </OptionalDatumCol>
        </DataList>

        <h2>{aliases.affiliate} Payout</h2>
        <DataList className="row">
          <OptionalDatumCol label="Call Result">{result}</OptionalDatumCol>

          <OptionalDatumCol label={payInLabel[reportMetadata.user]}>
            {renderMoney(payIn)}
          </OptionalDatumCol>

          <OptionalDatumCol label={payOutLabel[reportMetadata.type]}>
            {renderMoney(payOut)}
          </OptionalDatumCol>

          <OptionalDatumCol label="Margin">
            {renderMoney(margin)}
          </OptionalDatumCol>

          <OptionalDatumCol label="Fees">{renderMoney(fees)}</OptionalDatumCol>

          <OptionalDatumCol label={`${aliases.advertiser} Fees`}>
            {renderMoney(advertiserFees)}
          </OptionalDatumCol>

          <OptionalDatumCol label={payInConditionLabel[reportMetadata.user]}>
            {renderConditions(payInConditions)}
          </OptionalDatumCol>

          <OptionalDatumCol label="Payout Conditions">
            {renderConditions(payOutConditions)}
          </OptionalDatumCol>
        </DataList>
      </TileBody>
    </Tile>
  );
};

ConversionData.propTypes = {
  aliases: PropTypes.shape({
    affiliate: PropTypes.string.isRequired,
    advertiser: PropTypes.string.isRequired
  }),
  result: PropTypes.string,
  payIn: PropTypes.string,
  payInConditions: PropTypes.string,
  payOut: PropTypes.string,
  payOutConditions: PropTypes.string,
  margin: PropTypes.string,
  fees: PropTypes.string,
  advertiserFees: PropTypes.string,
  saleAmount: PropTypes.string,
  reportMetadata: PropTypes.shape({
    type: PropTypes.string.isRequired,
    user: PropTypes.string.isRequired
  }).isRequired
};

ConversionData.defaultProps = {
  aliases: { affiliate: "Affiliate", advertiser: "Advertiser" }
};

export default ConversionData;
